import { UserProfile, User, PermissionKey } from "@/types/permissions";

// Default system user profiles
export const mockUserProfiles: UserProfile[] = [
  {
    id: "profile-1",
    name: "Administrator",
    description: "Full access to all features and settings",
    isDefault: true,
    isSystem: true,
    permissions: [
      // All permissions
      "dashboard.view",
      "inventory.stock-items.view",
      "inventory.stock-items.create",
      "inventory.stock-items.edit",
      "inventory.stock-items.delete",
      "inventory.warehouses.view",
      "inventory.warehouses.create",
      "inventory.warehouses.edit",
      "inventory.warehouses.delete",
      "inventory.movements.view",
      "inventory.movements.create",
      "inventory.movements.edit",
      "inventory.movements.delete",
      "inventory.stock-takes.view",
      "inventory.stock-takes.create",
      "inventory.stock-takes.edit",
      "inventory.stock-takes.delete",
      "inventory.tracking.view",
      "inventory.tracking.edit",
      "purchasing.orders.view",
      "purchasing.orders.create",
      "purchasing.orders.edit",
      "purchasing.orders.delete",
      "purchasing.orders.approve",
      "purchasing.receive-goods.view",
      "purchasing.receive-goods.create",
      "purchasing.suppliers.view",
      "purchasing.suppliers.create",
      "purchasing.suppliers.edit",
      "purchasing.suppliers.delete",
      "sales.orders.view",
      "sales.orders.create",
      "sales.orders.edit",
      "sales.orders.delete",
      "sales.orders.approve",
      "sales.pick-pack.view",
      "sales.pick-pack.create",
      "sales.shipping.view",
      "sales.shipping.create",
      "sales.customers.view",
      "sales.customers.create",
      "sales.customers.edit",
      "sales.customers.delete",
      "master-data.projects.view",
      "master-data.projects.create",
      "master-data.projects.edit",
      "master-data.projects.delete",
      "manufacturing.boms.view",
      "manufacturing.boms.create",
      "manufacturing.boms.edit",
      "manufacturing.boms.delete",
      "manufacturing.work-orders.view",
      "manufacturing.work-orders.create",
      "manufacturing.work-orders.edit",
      "manufacturing.work-orders.delete",
      "manufacturing.production-schedule.view",
      "manufacturing.production-schedule.edit",
      "manufacturing.routing.view",
      "manufacturing.routing.edit",
      "ai.forecasting.view",
      "ai.abc-classification.view",
      "ai.reorder.view",
      "ai.reorder.approve",
      "pricing.matrix.view",
      "pricing.matrix.edit",
      "pricing.margin-analysis.view",
      "pricing.cost-analysis.view",
      "settings.custom-fields.view",
      "settings.custom-fields.create",
      "settings.custom-fields.edit",
      "settings.custom-fields.delete",
      "settings.integration.view",
      "settings.integration.edit",
      "settings.sync-status.view",
      "settings.stock-options.view",
      "settings.stock-options.edit",
      "settings.company-details.view",
      "settings.user-profiles.view",
      "settings.user-profiles.create",
      "settings.user-profiles.edit",
      "settings.user-profiles.delete",
      "settings.users.view",
      "settings.users.create",
      "settings.users.edit",
      "settings.users.delete",
      "settings.tax-rates.view",
      "settings.tax-rates.create",
      "settings.tax-rates.edit",
      "settings.tax-rates.delete",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
  {
    id: "profile-2",
    name: "Warehouse Manager",
    description: "Manage inventory, stock movements, and warehouse operations",
    isDefault: true,
    isSystem: true,
    permissions: [
      "dashboard.view",
      "inventory.stock-items.view",
      "inventory.stock-items.create",
      "inventory.stock-items.edit",
      "inventory.warehouses.view",
      "inventory.warehouses.create",
      "inventory.warehouses.edit",
      "inventory.movements.view",
      "inventory.movements.create",
      "inventory.movements.edit",
      "inventory.stock-takes.view",
      "inventory.stock-takes.create",
      "inventory.stock-takes.edit",
      "inventory.tracking.view",
      "inventory.tracking.edit",
      "purchasing.receive-goods.view",
      "purchasing.receive-goods.create",
      "settings.company-details.view",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
  {
    id: "profile-3",
    name: "Purchasing Manager",
    description: "Manage purchase orders, suppliers, and goods receipt",
    isDefault: true,
    isSystem: true,
    permissions: [
      "dashboard.view",
      "inventory.stock-items.view",
      "purchasing.orders.view",
      "purchasing.orders.create",
      "purchasing.orders.edit",
      "purchasing.orders.delete",
      "purchasing.orders.approve",
      "purchasing.receive-goods.view",
      "purchasing.receive-goods.create",
      "purchasing.suppliers.view",
      "purchasing.suppliers.create",
      "purchasing.suppliers.edit",
      "purchasing.suppliers.delete",
      "master-data.projects.view",
      "pricing.cost-analysis.view",
      "settings.company-details.view",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
  {
    id: "profile-4",
    name: "Sales Manager",
    description: "Manage sales orders, customers, and fulfillment",
    isDefault: true,
    isSystem: true,
    permissions: [
      "dashboard.view",
      "inventory.stock-items.view",
      "sales.orders.view",
      "sales.orders.create",
      "sales.orders.edit",
      "sales.orders.delete",
      "sales.orders.approve",
      "sales.pick-pack.view",
      "sales.pick-pack.create",
      "sales.shipping.view",
      "sales.shipping.create",
      "sales.customers.view",
      "sales.customers.create",
      "sales.customers.edit",
      "sales.customers.delete",
      "master-data.projects.view",
      "pricing.matrix.view",
      "pricing.margin-analysis.view",
      "settings.company-details.view",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
  {
    id: "profile-5",
    name: "Production Manager",
    description: "Manage manufacturing, BOMs, and production scheduling",
    isDefault: true,
    isSystem: true,
    permissions: [
      "dashboard.view",
      "inventory.stock-items.view",
      "inventory.movements.view",
      "manufacturing.boms.view",
      "manufacturing.boms.create",
      "manufacturing.boms.edit",
      "manufacturing.boms.delete",
      "manufacturing.work-orders.view",
      "manufacturing.work-orders.create",
      "manufacturing.work-orders.edit",
      "manufacturing.work-orders.delete",
      "manufacturing.production-schedule.view",
      "manufacturing.production-schedule.edit",
      "manufacturing.routing.view",
      "manufacturing.routing.edit",
      "settings.company-details.view",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
  {
    id: "profile-6",
    name: "Warehouse Operator",
    description: "View-only access to inventory with basic movement creation",
    isDefault: true,
    isSystem: true,
    permissions: [
      "dashboard.view",
      "inventory.stock-items.view",
      "inventory.warehouses.view",
      "inventory.movements.view",
      "inventory.movements.create",
      "inventory.tracking.view",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
  {
    id: "profile-7",
    name: "Analyst",
    description: "View-only access to reports, analytics, and forecasting",
    isDefault: true,
    isSystem: true,
    permissions: [
      "dashboard.view",
      "inventory.stock-items.view",
      "inventory.movements.view",
      "ai.forecasting.view",
      "ai.abc-classification.view",
      "ai.reorder.view",
      "pricing.matrix.view",
      "pricing.margin-analysis.view",
      "pricing.cost-analysis.view",
      "settings.company-details.view",
    ] as PermissionKey[],
    createdAt: "2024-01-01T00:00:00Z",
    updatedAt: "2024-01-01T00:00:00Z",
  },
];

// Mock users
export const mockUsers: User[] = [
  {
    id: "user-1",
    name: "John Admin",
    email: "john.admin@stockevo.com",
    profileId: "profile-1",
    isActive: true,
    createdAt: "2024-01-01T00:00:00Z",
    lastLogin: "2024-01-15T10:30:00Z",
  },
  {
    id: "user-2",
    name: "Sarah Warehouse",
    email: "sarah.warehouse@stockevo.com",
    profileId: "profile-2",
    isActive: true,
    createdAt: "2024-01-02T00:00:00Z",
    lastLogin: "2024-01-15T09:15:00Z",
  },
  {
    id: "user-3",
    name: "Mike Purchasing",
    email: "mike.purchasing@stockevo.com",
    profileId: "profile-3",
    isActive: true,
    createdAt: "2024-01-03T00:00:00Z",
    lastLogin: "2024-01-15T08:45:00Z",
  },
  {
    id: "user-4",
    name: "Emma Sales",
    email: "emma.sales@stockevo.com",
    profileId: "profile-4",
    isActive: true,
    createdAt: "2024-01-04T00:00:00Z",
    lastLogin: "2024-01-14T16:20:00Z",
  },
  {
    id: "user-5",
    name: "David Production",
    email: "david.production@stockevo.com",
    profileId: "profile-5",
    isActive: true,
    createdAt: "2024-01-05T00:00:00Z",
    lastLogin: "2024-01-15T07:30:00Z",
  },
  {
    id: "user-6",
    name: "Lisa Operator",
    email: "lisa.operator@stockevo.com",
    profileId: "profile-6",
    isActive: true,
    createdAt: "2024-01-06T00:00:00Z",
    lastLogin: "2024-01-15T11:00:00Z",
  },
  {
    id: "user-7",
    name: "Tom Analyst",
    email: "tom.analyst@stockevo.com",
    profileId: "profile-7",
    isActive: true,
    createdAt: "2024-01-07T00:00:00Z",
    lastLogin: "2024-01-15T09:45:00Z",
  },
  {
    id: "user-8",
    name: "Rachel Inactive",
    email: "rachel.inactive@stockevo.com",
    profileId: "profile-6",
    isActive: false,
    createdAt: "2024-01-08T00:00:00Z",
    lastLogin: "2024-01-10T14:20:00Z",
  },
];
